import { Card, CardContent } from "../ui/card";

const ExperienceCard = ({ title, company, period, location, description }) => (
  <Card className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
    <CardContent className="p-6">
      <h3 className="font-bold text-xl text-[#57068C]">{title}</h3>
      <p className="text-gray-700 font-medium text-lg">{company}</p>
      <p className="text-gray-500 mt-1">
        {period} | {location}
      </p>
      <div className="mt-4 text-gray-600 leading-relaxed">{description}</div>
    </CardContent>
  </Card>
);

const Experience = () => (
  <section className="transition-opacity duration-300">
    <h2 className="text-3xl font-bold mb-8 text-[#57068C]">
      Professional Experience
    </h2>
    <div className="space-y-8">
      <ExperienceCard
        title="Course Assistant"
        company="New York University"
        period="Sept 2024 - May 2025"
        location="New York City, NY"
        description={
          <>
            <p className="mb-4">
              College of Arts and Sciences - Psychology Department
            </p>
            <ul className="list-disc pl-4 space-y-2">
              <li>
                Provided academic support for undergraduate psychology courses,
                including general and advanced courses, by proctoring exams,
                grading assignments, and assisting with course administration
              </li>
              <li>
                Held weekly office hours and met individually with students to
                clarify course content, reinforce expectations, and support
                academic success
              </li>
              <li>
                Collaborated with faculty to prepare course materials, manage
                classroom logistics, and ensure effective delivery of course
                content.
              </li>
            </ul>
          </>
        }
      />
      <ExperienceCard
        title="Clinic Coordinator"
        company="New York University"
        period="Jan 2024 - Sept 2024"
        location="New Tork City, NY"
        description={
          <>
            <p className="mb-4">
              Steinhardt School - Department of Communicative Sciences and
              Disorders
            </p>
            <ul className="list-disc pl-4 space-y-2">
              <li>
                Managed patient intake and scheduling, including confirming,
                rescheduling, and coordinating appointments to ensure efficient
                clinic operations and high-quality patient service.
              </li>
              <li>
                Audited and updated electronic health records (EHR) to maintain
                accuracy and ensure compliance with HIPAA regulations and clinic
                protocols.
              </li>
              <li>
                Supported clinic operations by coordinating deliveries,
                assisting with event planning for student programs, and serving
                as a key administrative liaison between patients, staff, and
                program participants.
              </li>
            </ul>
          </>
        }
      />
      <ExperienceCard
        title="Patient Access Coordinator"
        company="NOVA Southeastern University"
        period="July 2022 - July 2023 2013"
        location="Miami, Florida"
        description={
          <>
            <p className="mb-4">
              College of Osteopathic Medicine - Institute for Neuro-Immune
              Medicine
            </p>
            <ul className="list-disc pl-4 space-y-2">
              <li>
                Coordinated front desk operations in a healthcare clinic,
                managing patient intake, appointment scheduling, and insurance
                verification. Communicated with patients worldwide to coordinate
                care, supported billing processes, and liaised with insurance
                providers to ensure coverage and continuity of care for
                individuals with neuro-immunological conditions.
              </li>
              <li>
                Maintained and audited electronic health records (EHR) to ensure
                accuracy, HIPAA compliance, and up-to-date clinical
                documentation. Oversaw medical deliveries and supported
                administrative communication between patients, clinicians, and
                interdisciplinary staff.
              </li>
            </ul>
          </>
        }
      />
    </div>
  </section>
);

export default Experience;
